<template>
  <ship-bulk v-if="ship.type === 'tanker' || ship.type === 'bulk carrier'" v-bind:ship="ship" view="plan"/>
</template>

<script>
import ShipBulk from "./ShipBulk.vue";

export default {
  name: "ShipProfile",
  components: {
    ShipBulk
  },
  props: {
    ship: Object,
  },
};
</script>
